var _a;
import _extends from "@babel/runtime/helpers/extends";
import { Grid } from '@mui/material';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { gridClasses } from "@mui/x-data-grid-premium";
import * as React from 'react';
import { ArrowDownIconNew } from '../../../assets/images';
import CustomPagination from './pagination';
var useStyles = {
    dataGrid: (_a = {
            "--DataGrid-containerBackground": 'white',
            border: '0px 1px 0px 1px',
            borderRadius: 0,
            '&.MuiDataGrid-root ': {
                flexDirection: "column-reverse",
                border: 0
            },
            "& .MuiDataGrid-cell": {
                fontSize: 'sm',
                justifyContent: 'left',
                textTransform: 'capitalize',
                overflow: "hidden",
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            },
            '& .MuiDataGrid-columnHeaders': {
                borderRadius: 0,
                justifyContent: 'left',
                borderTop: "1px solid rgba(224, 224, 224, 1)"
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: 'sm',
                fontWeight: 'medium',
                // marginLeft: 1.3,
                color: 'text.secondary'
                // padding: '16px 32px 16px 32px'
            },
            '& .MuiDataGrid-row': {
                // margin: 1,
                fontSize: 'sm'
                // fontWeight: 400,
            },
            // '& .MuiTablePagination-root': {
            //   overflow: 'hidden'
            // },
            // '& .MuiTablePagination-select': {
            //   paddingLeft: 0,
            //   paddingRight: 0,
            // },
            // "& .MuiDataGrid-footerContainer": {
            //   minHeight: 0,
            // },
            '& .MuiTablePagination-displayedRows': {
                marginRight: 8
            },
            '& .MuiTablePagination-actions': {
                display: 'none'
            },
            '& .MuiInputBase-root': {
                left: 12
            },
            '& .css-11bgdin-MuiSelect-icon ': {
                top: 'calc(43% - .5em)'
            },
            '& .css-17kmy9x-MuiSelect-icon': {
                top: 'calc(43% - .5em)'
            },
            '& .css-15ghnva-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root-MuiTablePagination-select .MuiTablePagination-select': {
                padding: 0
            },
            '.MuiDataGrid-cell:focus': {
                outline: ' none !important'
            },
            ".MuiDataGrid-footerContainer": {
                border: 0
            }
        },
        _a[".".concat(gridClasses['cell--textLeft'])] = {
            placeContent: 'center'
        },
        _a[".".concat(gridClasses['container--top'])] = {
            top: 1
        },
        _a),
    grid: {
        display: "flex",
        flexDirection: "column-reverse"
    }
};
var Customicon = function (props) {
    return /*#__PURE__*/ React.createElement("img", _extends({
        src: ArrowDownIconNew,
        width: 20,
        height: 20,
        style: {
            marginLeft: '-25px'
        },
        alt: "settingIcon",
        loading: "lazy"
    }, props));
};
var DataGridCommonComp = function (props) {
    var totalCount = props.totalCount, pageSizeOptions = props.pageSizeOptions, getRowId = props.getRowId, onCardClick = props.onCardClick, paginationModel = props.paginationModel, rows = props.rows, columns = props.columns, handlePageChange = props.handlePageChange, handlePageSizeChange = props.handlePageSizeChange, parentComponent = props.parentComponent, loading = props.loading;
    var apiRef = useGridApiRef();
    var gridRef = React.useRef(null);
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 'auto',
            width: 'auto',
            border: '1px solid #DEE4EB',
            borderRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(DataGrid, {
        className: "useStyles.dataGrid",
        getRowId: getRowId,
        apiRef: apiRef,
        rows: rows,
        columns: columns,
        paginationMode: "server"
        // disableDensitySelector
        ,
        initialState: {
            pagination: {
                paginationModel: paginationModel
            }
        }
        // initialState={{ pinnedColumns: { left: ['name'], right: ['actions'] } }}
        ,
        pageSizeOptions: pageSizeOptions,
        rowCount: totalCount,
        paginationModel: paginationModel,
        sx: useStyles.dataGrid,
        autoPageSize: false,
        onRowClick: function (event) {
            onCardClick(event.row.id);
        },
        showColumnVerticalBorder: true,
        slotProps: {
            pagination: {
                sx: {
                    minHeight: "80px",
                    placeContent: 'center'
                },
                labelRowsPerPage: 'Showing',
                labelDisplayedRows: function (_ref) {
                    var from = _ref.from, to = _ref.to, count = _ref.count;
                    return "of ".concat(count, " Results");
                },
                SelectProps: {
                    IconComponent: Customicon,
                    variant: 'outlined',
                    sx: {
                        padding: 1,
                        border: '0.5px solid #DEE4EB',
                        borderRadius: '8px',
                        height: '40px'
                    },
                    id: "paging-dropdown"
                },
                onRowsPerPageChange: function (event) {
                    // handlePaginationFunction(event.target.value)
                    handlePageSizeChange(event.target.value);
                    // handlePageSizeChange()
                }
            }
        },
        rowHeight: 72,
        columnHeaderHeight: 44,
        loading: loading
    }), /*#__PURE__*/ React.createElement(Grid, {
        xs: 12
    }, /*#__PURE__*/ React.createElement(CustomPagination, {
        count: Math.ceil(totalCount / paginationModel.pageSize),
        page: paginationModel.page + 1,
        onPageChange: handlePageChange,
        pageSize: paginationModel.pageSize,
        onPageSizeChange: handlePageSizeChange
    })));
};
export default DataGridCommonComp;
